import type { AiDetectionBBox, Annotation, DetectionObj } from "~/types/annotations";
import type { BridgeElement } from "~/types/bridge";
import type { DefectType, ElementGroup, ElementType } from "~/types/defects";

const getAnnotationsByElementsObjectId = (imageAnnotations: Annotation[], objectId: string) => {
    const results: any[] = [];
    imageAnnotations.forEach((annotation: Annotation) => {
        if (annotation.defect_code !== '0') {
            if (annotation.entity == objectId) {
                const newAnnotation = { ...annotation };
                //   newAnnotation.name = annotation.defect_type;
                results.push(newAnnotation);
            }
        }
    });
    return results;
};

export const getElementsWithDeffects = (
    bridgeElements: BridgeElement[],
    imageAnnotations: Annotation[]
) => {
    const results: BridgeElement[] = [];
    bridgeElements.forEach((el: BridgeElement) => {
        const annByObjectId = getAnnotationsByElementsObjectId(imageAnnotations, el.object_id)
        if (annByObjectId.length) {
            const newElement = { ...el };
            newElement.annotations = annByObjectId;
            results.push(newElement);
        }
    });
    return results;
};

export const getElementsByTypeId = (
    typeId: number,
    elements: BridgeElement[]) => {
    const results: BridgeElement[] = [];
    elements.forEach(el => {
        if (el.element_type_id == typeId) {
            results.push(el);
        }
    });
    return results;
};

export const getTypesWithElementsWithDeffects = (
    elementsTypes: ElementType[],
    elements: BridgeElement[]
) => {
    const types: ElementType[] = [];
    elementsTypes.forEach((type: ElementType) => {
        const elementsByType = getElementsByTypeId(type.id, elements);
        if (elementsByType.length) {
            const newType = { ...type };
            newType.elements = elementsByType;
            types.push(newType);
        }
    });
    return types;
};

export const getTypesByGroupId = (
    groupId: number,
    typesWithElements: ElementType[]) => {
        const results: ElementType[] = [];
        typesWithElements.forEach(type => {
            if (type.element_group_id == groupId) {
                results.push(type);
            }
        });
        return results;
    };

export const getGroupsWithTypes = (
    elementsGroups: ElementGroup[],
    typesWithElements: ElementType[],
    unAllocatedElements: BridgeElement[]
):ElementGroup[] => {
        const groups: ElementGroup[] = [];
        elementsGroups.forEach((group: ElementGroup) => {
            const typesByGroup = getTypesByGroupId(group.id, typesWithElements);
            if (typesByGroup.length) {
                const newGroup = { ...group };
                newGroup.types = typesByGroup;
                groups.push(newGroup);
            }
        });
        groups.push({
            id: -1,
            organization_id: -1,
            group_number: "-1",
            name: 'Other',
            description: 'Unallocated elements',
            elements: [...unAllocatedElements],
        });
        return groups;
    };

  export  const getDefectCodesWithAnnotaton = (
    annotationType: string,
    defectTypes: DefectType[],
    imageAnnotations: Annotation[]    
) => {
        const defectCodes = defectTypes
            .filter((defectType: DefectType) => defectType.annotation_type == annotationType)
            .map((defectType: DefectType) => ({
                name: `${defectType.defect_code} (${defectType.defect_typ})`,
                defect_code: defectType.defect_code,
                annotationType: defectType.annotation_type,
                items: imageAnnotations
                    .filter((annotation: Annotation) => annotation.defect_code == defectType.defect_code)
                    .map((annotation: Annotation) => ({
                        ...annotation,
                        name: annotation.defect_type,
                    })),
            }));
        return defectCodes.filter((def: any) => def.items.length);
        // return defectCodes.filter((def: DefectType) => def.annotations.length);
    };



export const detectionStringToObj = (detectionString: string): DetectionObj => {
    // console.log('detectionStringToObj', detectionString);
  const ditection = detectionString.split(',');
  // console.log(ditection);
  const imageLink = ditection[1]
  const className = ditection[4];
  const bbox : AiDetectionBBox = [
    ditection[5].slice(2),
    ditection[6].slice(1),
    ditection[7].slice(1),
    ditection[8].slice(0, ditection[8].length - 2).slice(1),
  ];
  const conf = +ditection[9];
  const color =  ditection[10] ? '#' + ditection[10].trim() : 'green';
//   console.log({
//     className,
//     bbox,
//     conf,
//     color,
//     imageLink
//   })
  return {
    className,
    bbox,
    conf,
    color,
    imageLink
  };
}